import React, { useState } from "react";
import {Dialog} from 'primereact/dialog';
import GenericUI from "../generic.ui";
import {Translator} from "../../translator";
import { RegistrationAPI } from "../../../api/registration";

//import "./styles/smartphone.css";
//import "./styles/tablet.css";
import "./styles/desktop.css";

export default class RegisterPanel extends GenericUI
{
    constructor( props ) {
        super( props );
        this.state = {
            visible: props.visible
        };
    }

    componentDidMount()
    {
        window.RegisterPanel = this;
    }

    logout(e)
    {
        if( window.ConfirmDialogBox )
        {
            window.ConfirmDialogBox.show( 'confirm_logout', 'logout_confirm_message', () => {
                if( window.localStorage) localStorage.clear();
                if( window.sessionStorage) sessionStorage.clear();
                window.open('index.html', '_self');
            } );
        }
    }

    registerAccount()
    {
        var firstname = document.getElementById('firstname').value;
        var lastname = document.getElementById('lastname').value;
        var email = document.getElementById('email').value;
        var password = document.getElementById('password').value;
        var confirm_password = document.getElementById('confirm_password').value;

        if( firstname === undefined || firstname === '' )
        {
            if( window.Messenger )
            {
                window.Messenger.showMessage( 'error', 'firstname_required' );
            }
            return;
        }

        if( lastname === undefined || lastname === '' )
        {
            if( window.Messenger )
            {
                window.Messenger.showMessage( 'error', 'lastname_required' );
            }
            return;
        }

        if( email === undefined || email === '' )
        {
            if( window.Messenger )
            {
                window.Messenger.showMessage( 'error', 'email_required' );
            }
            return;
        }

        if( !email.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ) ) {
            if( window.Messenger )
            {
                window.Messenger.showMessage( 'error', 'invalid_email' );
            }
            return;
        }

        if( password === undefined || password === '' )
        {
            if( window.Messenger )
            {
                window.Messenger.showMessage( 'error', 'password_required' );
            }
            return;
        }

        if( password !== confirm_password )
        {
            if( window.Messenger )
            {
                window.Messenger.showMessage( 'error', 'password_mismatch' );
            }
            return;
        }
        
        RegistrationAPI.account( firstname, lastname, email, password )
            .then( ( response ) => {
                if( response && response.data && response.data )
                {
                    this.setState( { visible: false } );
                    RegistrationAPI.licence( email, 'AOZF' )
                    .then( ( response ) => {
                        if( response && response.data && response.data )
                        {
                            if( window.Messenger )
                            {
                                window.Messenger.showMessage( 'success', 'account_creation_success' );
                            }
                            setTimeout( () => {
                                window.open('index.html', '_self');
                            },3000 );
                        }
                        else
                        {
                            if( window.Messenger )
                            {
                                window.Messenger.showMessage( 'error', 'account_creation_failed' );
                            }
                        }
                    } )
                    .catch( ( error ) => {
                        if( window.Messenger )
                        {
                            window.Messenger.showMessage( 'error', error );
                        }
                    });
                }
                else
                {
                    if( window.Messenger )
                    {
                        window.Messenger.showMessage( 'error', 'account_creation_failed' );
                    }
                }
            } )
        .catch( ( error ) => {
            if( window.Messenger )
            {
                window.Messenger.showMessage( 'error', error );
            }
        });
    }

    render()
    {
        super.render();
        if( this.state.visible )
        {
            return(
                <div className="mask">
                    <Dialog
                        modal
                        visible={this.state.visible}
                        onHide={() => this.setState( { visible: false } ) }
                        header={Translator.get("create_an_account")}
                        className="register-panel no-text-select"
                    >
                        <div className="register-form">
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="td-left label">{Translator.get("firstname")}</td>
                                        <td className="td-right"><input type="text" id="firstname" placeholder={Translator.get("enter_your_firstname")} /></td>
                                    </tr>
                                    <tr>
                                        <td className="td-left label">{Translator.get("lastname")}</td>
                                        <td className="td-right"><input type="text" id="lastname" placeholder={Translator.get("enter_your_lastname")}/></td>
                                    </tr>
                                    <tr>
                                        <td className="td-left label">{Translator.get("email")}</td>
                                        <td className="td-right"><input type="text" id="email" placeholder={Translator.get("enter_your_email")} /></td>
                                    </tr> 
                                    <tr>
                                        <td colSpan="2"><hr /></td>
                                    </tr>
                                    <tr>
                                        <td className="td-left label">{Translator.get("password")}</td>
                                        <td className="td-right"><input type="password" id="password" placeholder={Translator.get("enter_your_password")} /></td>
                                    </tr>                                                                                                            
                                    <tr>
                                        <td className="td-left label">{Translator.get("confirm_password")}</td>
                                        <td className="td-right"><input type="password" id="confirm_password" placeholder={Translator.get("confirm_password")} /></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div>&nbsp;</div>
                        <div className="register-buttons">
                            <button className="cancel" onClick={() => this.setState( { visible: false } )}>{Translator.get("cancel")}</button>
                            <button className="save" onClick={() => this.registerAccount()}>{Translator.get("confirm")}</button>
                        </div>
                    </Dialog>
                </div>
            );
        }
        else
        {
            return null;
        
        }
    }
}